export default __webpack_public_path__ + "b46eef4d4263d20396ecc242d1f132ee.svg";